import { IFRResource } from "app/resources/ifrresource";
import { TagResource } from "app/models/TagResource";

export class MTemplateDataResource extends IFRResource {

    rid: number;
    edit: String;
    template: string;
    metadata: string;
    path: String;
    descriptionRo: String;
    descriptionFr: String;
    descriptionEn: String;
    descriptionDe: String;
    nameFr: String;
    nameRo: String;
    nameEn: String;
    nameDe: String;
    news: boolean;
    cinema: boolean;
    newHtmlFlags: NewHtmlFlags;
    tags: TagResource[];
    showDelete: boolean = false;
    openMailRate: number;
    userEmail: string;

    showDetailsOnResponsive:boolean = false;
}

export class NewHtmlFlags {
    inputErrorTitleFR: boolean
    inputErrorTitleRO: boolean
    inputErrorTitleEN: boolean
    inputErrorTitleDE: boolean
    inputSuccessTitleFR: boolean
    inputSuccessTitleRO: boolean
    inputSuccessTitleEN: boolean
    inputSuccessTitleDE: boolean
    constructor() {
        this.inputErrorTitleFR = false
        this.inputErrorTitleRO = false
        this.inputErrorTitleEN = false
        this.inputErrorTitleDE = false
        this.inputSuccessTitleRO = false
        this.inputSuccessTitleFR = false
        this.inputSuccessTitleEN = false
        this.inputSuccessTitleDE = false
    }
}	